<template>
  <sc-page-base :loading="loading">
    <div v-if="appDetails" class="columns margin-logo">
      <div class="column is-10">
        <h1 class="title page-base__title has-text-primary">
          Integração com {{ appDetails.app_name }}
        </h1>
      </div>
      <div class="column is-2">
        <img :src="appDetails.image_url" v-if="appDetails.image_url" class="img-client" />
      </div>
    </div>

    <div v-if="initialStep">
      <sc-form>
        <template slot="fields" slot-scope="{ fields }">
          <div class="initial_step">
            <div class="initial_step__content">
              <h1><sc-icon icon="clipboard-check"></sc-icon></h1>
              <h2>Você precisa ter as informações abaixo:</h2>
              <p>Entre em contato com a transportadora e tenha em mãos as seguintes informações:</p>
              <ul>
                <li><sc-icon icon="address-card"></sc-icon> Credenciais com a transportadora</li>
                <li><sc-icon icon="address-book"></sc-icon> Contato da transportadora</li>
                <li><sc-icon icon="box"></sc-icon> Configurações de envio</li>
              </ul>
              <sc-button text="Concordar e continuar" theme="primary" @click="initialStep = false" />
            </div>
          </div>
        </template>
      </sc-form>
    </div>

    <div v-else class="columns">
      <div class="column is-12">
        <sc-steps class="self_service_steps" v-if="steps" v-model="activeStep" size="is-medium" :has-navigation="false">

          <sc-step-item
            v-for="(step, index) in steps"
            :key="index"
            :label="step.title"
            :step="index + 1"
            :clickable="false">

            <div>
              <sc-form autocomplete="off">
                <template slot="fields" slot-scope="{ fields }">
                  <component :is="step.component" :fieldGroupName="step.fieldGroupName" :fieldGroup="step.fieldGroup" ref="stepComponentsRef" />
                </template>

                <template slot="actions" slot-scope="{ isValid }">
                  <div>
                    <sc-button text="Voltar" @click="backStep()" theme="default" type="button" v-if="step.canBack && activeStep > 0"/>
                    <sc-button :class="step.name" text="Próximo" @click="navigateNext()" theme="primary" type="button"/>
                  </div>
                </template>
              </sc-form>
            </div>

          </sc-step-item>
          <sc-step-item :step="steps.length + 1" label="Concluído">
            <sc-finished />
          </sc-step-item>

        </sc-steps>
      </div>
    </div>
  </sc-page-base>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

import {
  ScPageBase,
  ScSteps,
  ScStepItem,
  ScForm,
  ScButton,
  ScIcon,
} from '@intelipost-js/secure-components';

import ScConfigWarehouses from './components/warehouse/ScConfigWarehouses.vue';
import ScConfig from './components/config/ScConfig.vue';
import ScContact from './components/ScContact.vue';
import ScShowCredentials from './components/ScShowCredentials.vue';
import ScInstructions from './components/ScInstructions.vue';
import ScFinished from './components/ScFinished.vue';
import ScCarrierCredentials from './components/credentials/ScCarrierCredentials';
import ScSysnode from './components/sysnode/ScSysnode';
import ScFreightTable from './components/ScFreightTable.vue';

const { mapState, mapActions, mapMutations } = createNamespacedHelpers('integrations/integrationsAppSelfService');

export default {
  name: 'integrations-app-self-service',
  components: {
    ScPageBase,
    ScSteps,
    ScStepItem,
    ScForm,
    ScButton,
    ScConfig,
    ScContact,
    ScShowCredentials,
    ScInstructions,
    ScFinished,
    ScConfigWarehouses,
    ScCarrierCredentials,
    ScSysnode,
    ScFreightTable,
    ScIcon,
  },
  data() {
    return {
      appDetails: null,
      steps: null,
      initialStep: true,
    };
  },
  async created() {
    this.setLoading(true);
    const appId = this.$route.params.id;

    this.loadAppDetails(appId).then((appDetails) => {
      this.appDetails = appDetails;
      this.afterLoadAppDetails();
    });
  },
  computed: {
    ...mapState([
      'loading',
      'activeStep',
    ]),
  },
  methods: {
    ...mapActions([
      'loadAppDetails',
    ]),
    ...mapMutations([
      'backStep',
      'nextStep',
      'setLoading',
    ]),
    afterLoadAppDetails() {
      const steps = [];
      if (this.appDetails.warehouse_fields && this.appDetails.warehouse_fields.length > 0) {
        steps.push({
          title: 'Centro de distribuição',
          name: 'startConfigWarehouseButton',
          component: ScConfigWarehouses,
          canBack: false,
        });
      }
      if (this.appDetails.credentials) {
        steps.push({
          title: 'Credenciais na Transportadora',
          name: 'startCredentialsButton',
          component: ScCarrierCredentials,
          fieldGroupName: 'credentials',
          fieldGroup: this.appDetails.credentials,
          canBack: true,
        });
      }
      if (this.appDetails.config) {
        steps.push({
          title: 'Transportadora',
          name: 'startConfigButton',
          component: ScConfig,
          fieldGroupName: 'config',
          fieldGroup: this.appDetails.config,
          canBack: true,
        });
      }
      if (this.appDetails.sysnode) {
        steps.push({
          title: 'Configurações de envio',
          name: 'startSysnodeButton',
          component: ScSysnode,
          fieldGroupName: 'sysnode',
          fieldGroup: this.appDetails.sysnode,
          canBack: true,
        });
      }
      steps.push({
        title: 'Contatos',
        name: 'startContactButton',
        component: ScContact,
        canBack: true,
      });
      if (this.appDetails.instructions) {
        steps.push({
          title: 'Instruções',
          name: 'startInstructionsButton',
          component: ScInstructions,
          canBack: false,
        });
      }
      steps.push({
        title: 'Credenciais na Intelipost',
        name: 'startShowCredentialsButton',
        component: ScShowCredentials,
        canBack: false,
      });
      steps.push({
        title: 'Tabela de frete',
        component: ScFreightTable,
        canBack: true,
      });

      this.steps = steps;
      this.setLoading(false);
    },

    navigateNext() {
      const stepComponent = this.$refs.stepComponentsRef[this.activeStep];

      if (stepComponent.validate && !stepComponent.validate()) {
        return;
      }
      if (stepComponent.executeOnFinish) {
        stepComponent.executeOnFinish().then(() => {
          this.nextStep();
        });
      } else {
        if (stepComponent.createTickets && stepComponent.includeFreightTable) {
          stepComponent.createTickets();
        }
        this.nextStep();
      }
    },
  },
  watch: {
    activeStep(newValue) {
      const stepComponent = this.$refs.stepComponentsRef[newValue];
      if (stepComponent && stepComponent.invalidate) {
        stepComponent.invalidate();
      }
      if (stepComponent && stepComponent.refresh) {
        stepComponent.refresh();
      }
    },
  },
};
</script>

<style lang='scss'>
@import "~@intelipost-js/secure-ui/src/scss/variables";

.img-client {
  height: 80px;
}

.margin-logo {
  margin-top: 10px;
}

.self_service_steps {
  ul {
    gap: 0.5em;
  }
}

.initial_step {
  display: flex;
  justify-content: center;

  &__content {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: min-content;

    h1 {
      margin-top: 20px;
      font-size: 150%;
      margin-bottom: 25px;
    }
    h2 {
      font-size: 122%;
      font-weight: bolder;
      color: black;
      margin-bottom: 5px;
    }
    p {
      text-align: center;
    }
    ul {
      background-color: #fafafa;
      padding: 8px;
      border-radius: 10px;
      white-space: nowrap;
      margin: 20px 35px;
      line-height: 2.8;

      .icon {
        margin-right: 5px;
      }
    }
    button {
      align-self: stretch;
      margin: 10px 35px;
    }
  }
}
</style>




// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-integrations/features/integrations-app-self-service/IntegrationsAppSelfService.vue